import { useLocation, Navigate, Outlet } from 'react-router-dom'
import { useEffect, useState } from 'react'

import useAuth from '../hooks/useAuth'
import axios from '../api/axios'

const RequireAuth = () => {
  const { auth } = useAuth()

  const location = useLocation()

  if(!auth?.user) {
    // redirect to login
    return <Navigate to='/' state={{ from: location }} replace />
  }

  const isImpersonating = !!localStorage.getItem("token")

  if (auth.user || isImpersonating) {
    return <Outlet />
  }

  return <Navigate to='/' state={{ from: location }} replace />
}

export default RequireAuth
